import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/es/storage';
import authReducer from '@store/authStore';
import appReducer from '@store/appStore';
import krispisReducer from 'src/shared/store/krispisStore';

const appPersistConfig = {
    key: 'app',
    storage,
    blacklist: ['isLoading', 'alert']
};

const authPersistConfig = {
    key: 'auth',
    storage
};

const krispisPersistConfig = {
    key: 'krispis',
    storage
};

const rootReducer = combineReducers({
    app: persistReducer(appPersistConfig, appReducer),
    auth: persistReducer(authPersistConfig, authReducer),
    krispis: persistReducer(krispisPersistConfig, krispisReducer)
});

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        })
});

export const persistor = persistStore(store);

export type RootReducer = ReturnType<typeof store.getState>;

export default store;
